<script>
  import FileInput from "../../components/form/FileInput.svelte";
  import DynamicDialog from "./dynamicDialog.svelte";
  import GenericButton from "../../components/button/GenericButton.svelte";
  import { sendFileFormDataRequest } from "../../api/crud";
  import videoUploadStore from "../../stores/Video/videoUpload";
  import CustomIcon from "../../components/CustomIcon.svelte";
  import Form from "../../components/form/Form.svelte";
  import Validators from "../../utils/validators";
  import InputWrapper from "../../components/form/InputWrapper.svelte";
  import FormButtons from "../../components/form/FormButtons.svelte";

  export let showModal = false;
  export let onClose = () => (showModal = false);
  let form;
  let files = [];
  let csv;
  let csvData;
  let formData = new FormData();
  let response;
  let loading = false;
  let CsvErrors = [];

  $: csvValid = csvData && csvData.length > 0;
  // function getForm()
  function closeModal(force) {
    if (loading && !force) return;
    reset();
    showModal = false;
  }
  let rules = {
    files: {
      validators: [Validators.required("File folder are required")],
    },
    csv: {
      validators: [Validators.required("CSV is required")],
    },
  };
  function reset() {
    //showModal = false;
    response = null;
    files = [];
    csv = null;
    response = null;
  }
  async function onSubmit(e) {
    e.preventDefault();
    loading = true;
    //let fm = new FormData(e.target);
    videoUploadStore.SetFiles(formData, csvData, onClose);
    closeModal(true);
  }
  async function OnInputCsvHandle(e) {
    //console.log(e.target);
    const { form } = e.target;
    const fd = new FormData(form);
    CsvErrors = [];
    const response = await sendFileFormDataRequest(
      "/topper/parse/csv",
      fd,
      "formData"
    );
    //filter out errors that are not from columns
    const responseErrors = response.errors.filter((err) => err.isGlobal);
    // filterOut blocking errors
    if (responseErrors.length) {
      CsvErrors = responseErrors;
      return;
    }
    csvData = response.toppers;
    const blockingErrors = response.errors.filter((err) => err.isBlocking);
    // apply blocking errors to csv Data
    if (blockingErrors.length) {
      blockingErrors.forEach((err) => {
        const errAtIndex = err.index-1
        if (err && err.index && csvData[errAtIndex]) {
          csvData[errAtIndex] = {
            ...csvData[errAtIndex],
            blockingErr: err.message,
          };
        }
      });
    }

    csv = fd.get("csv");
  }

  function onInput(e) {
    try {
      const { form } = e.target;
      const csvFiles = csvData.map((c) => c.original_filename);
      console.log(csvFiles);
      const fd = new FormData(form);
      files = Array.from(e.target.files).filter((f) =>
        csvFiles.includes(f.name)
      );
      formData = fd;
      return;
    } catch (error) {
      console.log(error);
    }
  }
</script>

<DynamicDialog onClose={closeModal} title="Assets Bulk Upload" bind:showModal>
  <!-- {#if !loading} -->

  <Form {rules} on:submit={onSubmit} bind:this={form}>
    <InputWrapper name="csv">
      <FileInput
        title="Upload CSV"
        accept={".csv"}
        name="csv"
        bind:display={csv}
        onInput={OnInputCsvHandle}
        multiple={false}
      />
    </InputWrapper>
    {#if CsvErrors.length}
      {#each CsvErrors as error}
        <p class="text-red-500 text-xs">
          {error.message}
          {error.index ? `at row ${error.index}` : ""}
        </p>
      {/each}
    {:else}
      <div class="mb-2" />
    {/if}
    <InputWrapper name="files">
      <FileInput
        title="Select folder for video files"
        name="files"
        {onInput}
        display={files}
        folder={true}
        multiple={true}
        disabled={!csvValid}
      />
    </InputWrapper>
    <p class="text-red-500 text-xs">
      Only the video files provided in the CSV file will be uploaded.
    </p>
    <div class="pt-2 flex justify-center w-full bg-white h-14 flex-initial">
      <!-- if the video is uploading, this will be the button state -->
      <GenericButton
        {loading}
        disabled={!csv || !files.length || loading}
        width="12rem"
        text="Upload"
        submit="true"
      />
    </div>
    <a
      href="/assets/template.csv"
      download
      class="flex font-medium hover:text-gray-700 items-center justify-center m-auto pt-1 text-center text-orange-500 text-sm"
    >
      Download CSV template <CustomIcon name="download" color="#EAB308" />
    </a>
  </Form>

  <!-- {:else} -->
  <!-- {:else if response.errors.length}
      <div>
        Errors
        {#each response.errors as message}<div class="pl-1">
            {message}
          </div>{/each}
      </div>
      <GenericButton text="Try Again" onClick={reset} />
    {:else if response.toppers.length}
      <ul class="">
        successfully updated
        {#each response.toppers as file}<li class="pl-1">
            {file.title}
          </li>{/each}
      </ul>
      <GenericButton text="Upload More" onClick={reset} />
    {:else}
      <div>Incorrect CSV</div>
      <GenericButton text="Try Again" onClick={reset} />
     -->
  <!-- {/if} -->
</DynamicDialog>
